import { useState, useCallback } from 'react';

const MAX = 4;

export function useCompare() {
  const [list, setList] = useState([]);
  const toggle = useCallback((id) => {
    setList(cur => {
      if (cur.includes(id)) return cur.filter(x => x !== id);
      if (cur.length >= MAX) return cur; // toast handled by caller
      return [...cur, id];
    });
  }, []);
  const clear = useCallback(() => setList([]), []);
  return [list, toggle, clear];
}
